import ComponentAbstract from "./ComponentAbstract";
import _helper from "actions/_helper";
import i18n from "i18";

import { Box, Typography } from "@mui/material";

export default class PageAbstract extends ComponentAbstract {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      pageLoading: -1,
      pageDialogProps: null,
    };
  }

  async componentDidMount() {
    this.refresh(this.componentDidLoad.bind(this));
  }

  componentWillUnmount() {
    if (this.state.pageLoading === true) _helper.abortCurrentRequest();
  }

  refresh(cb) {
    this.changeState("pageLoading", true, async () => {
      await this.loadData();

      this.changeState("pageLoading", false, cb);
    });
  }

  async loadData() {
    return {};
  }

  componentDidLoad() {}

  insertPageHeader(page) {
    return (
      <Box className="flex column gap4" sx={{ padding: "0 0 30px" }}>
        {this.insertPageHeaderTitle(i18n.t(`pageHeader.${page}.title`))}
        <Box className="font f18 w200" sx={{ color: "var(--text-color)" }}>
          {i18n.t(`pageHeader.${page}.desc`)}
        </Box>
      </Box>
    );
  }

  insertPageHeaderTitle(text) {
    return (
      <Typography className="page-title" sx={{ color: "var(--text-color)" }}>
        {text}
      </Typography>
    );
  }
  insertPageBlock(key, content, cl = "centerV centerH") {
    return (
      <Box
        key={key}
        className={`flex w-full ${cl} rad13 shad o3`}
        sx={{ backgroundColor: "var(--backgroundCustom)" }}>
        {content}
      </Box>
    );
  }

  render() {
    globalThis.appPage = this;

    const { pageLoading, pageDialogProps } = this.state;

    return (
      <Box
        className="flex1 flex justify-center"
        sx={{ backgroundColor: "var(--background-price)" }}>
        {this.renderPage()}
        {!!pageLoading && this.insertLoading({ position: "absolute" })}
        {!!pageDialogProps &&
          this.insertDialog(
            pageDialogProps,
            this.changeState.bind(this, "pageDialogProps", null)
          )}
      </Box>
    );
  }
}
